module.exports = __webpack_public_path__ + "static/media/md-compass.eb8092af.svg";